import prepareLoginFields from '../actions/prepareLoginFields'
import prepareAddressFields from '../actions/prepareAddressFields'
import prepareAggregationFields from '../actions/prepareAggregationFields'
import prepareCommonFields from '../actions/prepareCommonFields'
import parsePredefinedCookieData from '../actions/parsePredefinedCookieData'
import setPredefinedCookieValues from '../actions/setPredefinedCookieValues'
import preparePasswordFields from '../actions/preparePasswordFields'
import prepareModuleFields from '../actions/prepareModuleFields'

export default [
  prepareLoginFields,
  prepareCommonFields,
  prepareAddressFields,
  prepareAggregationFields,
  prepareModuleFields,
  preparePasswordFields,
  parsePredefinedCookieData,
  {
    cookieExist: [setPredefinedCookieValues],
    cookieDoesNotExist: [],
    cookieParseError: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/app/chains/initializeFields.js